import {
  Box,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Heading,
  HStack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import { HiOutlinePlus, HiOutlineTrash } from "react-icons/hi";
import UuidPreview from "../../UuidPreview";
import RateAmountInput from "../../RateAmountInput";
import { createEmptyReinstatement } from "../../utils/placementDefaults";

const ReinstatementsEditor = ({ reinstatements = [], onChange }) => {
  const updateReinstatement = (reinstatementIndex, field, value) => {
    const updated = [...reinstatements];
    updated[reinstatementIndex] = {
      ...updated[reinstatementIndex],
      [field]: value,
    };
    onChange(updated);
  };

  const addReinstatement = () => {
    onChange([...reinstatements, createEmptyReinstatement()]);
  };

  const removeReinstatement = (reinstatementIndex) => {
    const updated = [...reinstatements];
    updated.splice(reinstatementIndex, 1);
    onChange(updated);
  };

  return (
    <Box>
      <HStack alignItems="center" mb={4}>
        <Heading size="md">Reinstatements</Heading>
        <IconButton
          icon={<HiOutlinePlus />}
          size="md"
          aria-label="Add Reinstatement"
          onClick={addReinstatement}
        />
      </HStack>

      <Table variant="simple" size="sm">
        <Thead>
          <Tr>
            <Th>ID</Th>
            <Th>Sequence #</Th>
            <Th>Number of Reinstatements</Th>
            <Th>Premium %</Th>
            <Th>Brokerage %</Th>
            <Th>Provisions</Th>
            <Th></Th>
          </Tr>
        </Thead>
        <Tbody>
          {reinstatements.map((reinstatement, reinstatementIndex) => (
            <Tr key={reinstatement.id}>
              <Td>
                <UuidPreview uuid={reinstatement.id} />
              </Td>
              <Td>
                <Input
                  size="sm"
                  type="number"
                  value={reinstatement.sequenceNbr}
                  onChange={(e) =>
                    updateReinstatement(
                      reinstatementIndex,
                      "sequenceNbr",
                      parseInt(e.target.value) || 0
                    )
                  }
                />
              </Td>
              <Td>
                <Input
                  size="sm"
                  type="number"
                  value={reinstatement.numberOfReinstatements}
                  onChange={(e) =>
                    updateReinstatement(
                      reinstatementIndex,
                      "numberOfReinstatements",
                      parseInt(e.target.value) || 0
                    )
                  }
                />
              </Td>
              <Td>
                <RateAmountInput
                  value={reinstatement.premium}
                  onChange={(value) =>
                    updateReinstatement(reinstatementIndex, "premium", value)
                  }
                />
              </Td>
              <Td>
                <RateAmountInput
                  value={reinstatement.brokerage}
                  onChange={(value) =>
                    updateReinstatement(reinstatementIndex, "brokerage", value)
                  }
                />
              </Td>
              <Td>
                <Input
                  size="sm"
                  value={reinstatement.provisions || ""}
                  onChange={(e) =>
                    updateReinstatement(reinstatementIndex, "provisions", e.target.value)
                  }
                />
              </Td>
              <Td>
                <IconButton
                  size="sm"
                  icon={<HiOutlineTrash />}
                  aria-label="Delete Reinstatement"
                  onClick={() => removeReinstatement(reinstatementIndex)}
                />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default ReinstatementsEditor;
